import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Select from "react-select";

const SearchableDropdown = ({ismap}) => {
  const navigate = useNavigate();
  const { items,locations } = useSelector((state) => state.getapiData);
 /*  locations.map((loc, index) => {
    return  {url:loc.url,name:loc.placename}
}) */
  const handleChange = (selectedOption) => {
   if(ismap)
    window.open(`/detailpage/${selectedOption.url}`, '_blank');
    else
    {
      navigate("/detailpage/" + selectedOption.url);
    }
  };

  return (
    <div className="selectBox">
      <Select
        placeholder="Enter your location"
        className="dropdown-input"
        options={locations}
        getOptionLabel={(option) => option?.acf?.placename}
        getOptionValue={(option) => option?.acf?.url}
        onChange={handleChange}
      />
    </div>
  );
};

export default SearchableDropdown;
